export const Message01 = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M14.25 3H13.4242C13.0755 1.29075 11.5605 0 9.75 0H3.75C1.68225 0 0 1.68225 0 3.75V13.3905C0 13.986 0.32625 14.5305 0.8505 14.811C1.089 14.9392 1.35075 15.0023 1.61175 15.0023C1.92375 15.0023 2.235 14.9115 2.50425 14.7323L4.71675 13.257C5.235 14.7083 6.6225 15.75 8.25 15.75H12.5228L15.4957 17.7323C15.7657 17.9123 16.0763 18.003 16.3883 18.003C16.6493 18.003 16.9102 17.9392 17.1495 17.811C17.6745 17.5305 18 16.986 18 16.3905V6.75C18 4.68225 16.3177 3 14.25 3ZM1.6725 13.4843C1.65825 13.4932 1.61625 13.5203 1.5585 13.4895C1.49925 13.458 1.49925 13.4078 1.49925 13.3912V3.75C1.49925 2.5095 2.50875 1.5 3.74925 1.5H9.74925C10.9897 1.5 11.9992 2.5095 11.9992 3.75V9C11.9992 10.2405 10.9897 11.25 9.74925 11.25H5.24925C5.004 11.25 4.8435 11.3693 4.8255 11.3813L1.6725 13.4843ZM16.5 16.3913C16.5 16.407 16.5 16.458 16.4408 16.4895C16.3815 16.5203 16.341 16.4932 16.3275 16.4842L13.1663 14.376C13.0433 14.2942 12.8985 14.25 12.75 14.25H8.25C7.272 14.25 6.43875 13.623 6.129 12.75H9.75C11.8177 12.75 13.5 11.0677 13.5 9V4.5H14.25C15.4905 4.5 16.5 5.5095 16.5 6.75V16.3913Z"
            fill="currentColor"
         />
      </svg>
   )
}
